import { ReactNode, Ref } from "react";
import { motion, useReducedMotion } from "motion/react";
import { QUINN_PANEL_GUTTER, QUINN_PANEL_TOP } from "../../utils";

type QuinnPanelShellProps = {
    panelRef: Ref<HTMLDivElement>;
    width: number;
    isResizing: boolean;
    children: ReactNode;
};

export function QuinnPanelShell({ panelRef, width, isResizing, children }: QuinnPanelShellProps) {
    const prefersReducedMotion = useReducedMotion();

    return (
        <motion.aside
            ref={panelRef}
            key="quinn-panel"
            initial={prefersReducedMotion ? { opacity: 0 } : { x: "100%" }}
            animate={prefersReducedMotion ? { opacity: 1 } : { x: 0 }}
            exit={prefersReducedMotion ? { opacity: 0 } : { x: "100%" }}
            transition={
                isResizing
                    ? { duration: 0 }
                    : { type: "spring", stiffness: 280, damping: 30, mass: 0.9 }
            }
            style={{
                width,
                top: QUINN_PANEL_TOP,
                right: QUINN_PANEL_GUTTER,
                bottom: 0,
            }}
            className="fixed z-[56] flex flex-col overflow-hidden rounded-t-3xl bg-white shadow-[-8px_0_24px_-8px_rgba(0,0,0,0.10)]"
            aria-label="Quinn"
        >
            {children}
        </motion.aside>
    );
}
